
export function initComparisons() {
    //console.log('init')
	var x, i;
	/* Find all elements with an "overlay" class: */
	x = document.getElementsByClassName("img-comp-overlay");
	for (i = 0; i < x.length; i++) {
		/* Once for each "overlay" element:
		pass the "overlay" element as a parameter when executing the compareImages function: */
		compareImages(x[i],i);
	}
	function numberToAlphabet(num) {
		if (num < 1 || num > 26) {
		  return ""; // Return empty string for invalid input
		}
		return String.fromCharCode(96 + num); // Use charCode to convert
	  }
	function compareImages(img,i) {
		//console.log(numberToAlphabet(i+1))
		var slider, img, clicked = 0, w, h;
		/* Get the width and height of the img element */
		w = img.offsetWidth;
		h = img.offsetHeight;
		/* Set the width of the img element to 50%: */
		img.style.width = (w / 2) + "px";
		/* Create slider: */
		slider = document.createElement("a");
		slider.setAttribute("class", "img-comp-slider");
		slider.setAttribute("id", "image-slider-compare-patient-"+numberToAlphabet(i+1));
		/* Insert slider */
		img.parentElement.insertBefore(slider, img);
		/* Position the slider in the middle: */
		slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
		slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
		/* Execute a function when the mouse button is pressed: */
		slider.addEventListener("mousedown", slideReady);
		/* And another function when the mouse button is released: */
		window.addEventListener("mouseup", slideFinish);
		/* Or touched (for touch screens: */
		slider.addEventListener("touchstart", slideReady);
		/* And released (for touch screens: */
		window.addEventListener("touchend", slideFinish);
		function slideReady(e) {
			/* Prevent any other actions that may occur when moving over the image: */
			e.preventDefault();
			/* The slider is now clicked and ready to move: */
			clicked = 1;
			/* Execute a function when the slider is moved: */
			window.addEventListener("mousemove", slideMove);
			window.addEventListener("touchmove", slideMove);
		}
		function slideFinish() {
			/* The slider is no longer clicked: */
			clicked = 0;
		}
		function slideMove(e) {
			var pos;
			/* If the slider is no longer clicked, exit this function: */
			if (clicked == 0) return false;
			/* Get the cursor's x position: */
			pos = getCursorPos(e)
			/* Prevent the slider from being positioned outside the image: */
			if (pos < 0) pos = 0;
			if (pos > w) pos = w;
			/* Execute a function that will resize the overlay image according to the cursor: */
			slide(pos);
		}
		function getCursorPos(e) {
			var a, x = 0;
			e = (e.changedTouches) ? e.changedTouches[0] : e;
			/* Get the x positions of the image: */
			a = img.getBoundingClientRect();
			/* Calculate the cursor's x coordinate, relative to the image: */
			x = e.pageX - a.left;
			/* Consider any page scrolling: */
			x = x - window.pageXOffset;
			return x;
		}
		function slide(x) {
			/* Resize the image: */
			img.style.width = x + "px";
			/* Position the slider: */
			slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
		}
	}
}


export function imgComparisonSlides() {
    //console.log('compare slider')
	let thisItemW = $('.slider-nav > .nav-item.active').outerWidth();
	let thisItemX = $('.slider-nav > .nav-item.active').position().left;
	let thisCurrentBgEl = $('.slider-nav > .nav-item-active-bg');
	let activeN = 0;
	thisCurrentBgEl.css({left:thisItemX,width:thisItemW});
	$('.slider-nav > .nav-item').click(function(e){
        e.preventDefault();
        //console.log('click patient')
		//unset all
		$('.slider-nav > .nav-item').removeClass('active');
		$('#slider-wrapper .slider-item').removeClass('active');

		//set this
		$(this).addClass('active');
		thisItemW = $(this).outerWidth();
		thisItemX = $(this).position().left;
		thisCurrentBgEl.css({left:thisItemX,width:thisItemW});
		activeN = $(this).data('n');
		$('#slider-wrapper .slider-item-'+activeN).addClass('active');

		
	})

	$(window).resize(function(){
		thisItemX = $('.slider-nav > .nav-item.active').position().left;
		thisItemW = $('.slider-nav > .nav-item.active').outerWidth();
		thisCurrentBgEl.css({left:thisItemX,width:thisItemW});
	})
}